/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { StoreItemsService } from '../../../customer/feature/store/services/storeitems.service';
import { StoreItemsResponse } from '../../../customer/feature/store/model/storeitemsresponse';
import { StoreItemsResultEntity } from '../../../customer/feature/store/model/storeitemsresponse';
import { DomSanitizer } from '@angular/platform-browser';
import { StoreItemFilterInfo } from '../../../customer/feature/store/model/storeitemfilterinfo';
import { StoreFilterService } from '../../../customer/feature/store/services/storefilter.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


declare var $: any;
@Component({
    selector: 'zsd-searchresult',
    templateUrl: './searchresult.component.html',
    styleUrls: ['./searchresult.component.scss'
    ]
})

export class SearchResultComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('zsdGlobalSearchStore', { static: false }) zsdGlobalSearchStore: ElementRef;

    storeHeight;
    requestsHeight;
    isStoreItems: boolean;
    storeItemDetails: StoreItemsResultEntity[] = [];
    storeItemFilterInfo: StoreItemFilterInfo = new StoreItemFilterInfo();
    rowList = [];
    page;
    carouselPage = 0;
    maxNoOfItems;
    filterSubscription: Subscription;
    itemsPerRow: number;
    carouselEndReached = false;
    isLoading: boolean;
    toggleIconFlag = true;
    spinnerStart = true; // adding for showing spinner while loading instead of No request message

    constructor(private storeItemsService: StoreItemsService, public _DomSanitizer: DomSanitizer,
        public storeFilterService: StoreFilterService, private ref: ChangeDetectorRef,
        public spinnerServcie: SpinnerService) {
        this.storeFilterService.applyFilter(this.storeItemFilterInfo);
        this.subscribeAndApplyFilters();
    }

    initializeParameters() {
        this.page = 0;
        this.isStoreItems = false;
        this.isLoading = false;
        this.storeItemDetails = [];
        this.rowList = [];
        this.storeItemFilterInfo = new StoreItemFilterInfo();
        this.onResizeCalculateItemsPerRow();
    }

    ngOnDestroy() {
        this.filterSubscription.unsubscribe();
    }

    subscribeAndApplyFilters() {
        this.filterSubscription = this.storeFilterService
        .getSearchFilter().pipe(
            debounceTime(400))
            .subscribe((filterInfo: StoreItemFilterInfo) => {
                this.carouselPage = 0;
                this.initializeParameters();
                this.storeItemFilterInfo = filterInfo;
                this.getStoreItems(this.storeItemFilterInfo);
            });
    }

    ngOnInit() {

        $('.carousel-control-prev').hide();
        const self = this;
        $('#storeCarouselControls').on('slid.bs.carousel', function () {
            $('.carousel-control-prev').show();
            $('.carousel-control-next').show();

            self.carouselPage = $('.carousel-item.active').index() - 1;

            if ($('.carousel-inner .carousel-item:first').hasClass('active')) {
                $('.carousel-control-prev').hide();
            } else if ($('.carousel-inner .carousel-item:last').hasClass('active')) {
                $('.carousel-control-next').hide();

                if (!self.carouselEndReached) {
                    self.getStoreItems(this.storeItemFilterInfo);
                }

            }
        });

        this.initializeParameters();

    }

    ngAfterViewInit() {
        this.ref.detectChanges();
        this.calculatePadding();
    }

    calculatePadding() {
        this.storeHeight = this.zsdGlobalSearchStore.nativeElement.offsetHeight + 'px';
        this.requestsHeight = this.zsdGlobalSearchStore.nativeElement.offsetHeight + 48 + 'px'; // 65 for requests heading and padding
        this.ref.detectChanges();
    }

    @HostListener('window:orientationchange') onorientationchange() {
        this.onResizeCalculateItemsPerRow();
      }

    onResizeCalculateItemsPerRow() {
        const oldItemsPerRow = (this.itemsPerRow === undefined) ? 0 : this.itemsPerRow;
        this.carouselPage = (this.carouselPage === undefined) ? 0 : this.carouselPage;
        if (window.innerWidth >= 1200) {
            this.itemsPerRow = 6;
        } else if (window.innerWidth >= 992) {
            this.itemsPerRow = 4;
        } else if (window.innerWidth >= 768) {
            this.itemsPerRow = 3;
        } else if (window.innerWidth >= 576) {
            this.itemsPerRow = 3;
        } else {
            this.itemsPerRow = 2;
        }
        this.rowList = this.carouselViewGenerator();
        this.carouselPage = Math.floor((this.carouselPage * oldItemsPerRow) / this.itemsPerRow);
        this.ref.detectChanges();
        this.calculatePadding();

    }

    getStoreItems(storeItemFilterInfo: StoreItemFilterInfo) {
        if (!this.isLoading) {
            this.isLoading = true;
            this.ref.detectChanges();
            this.calculatePadding();

            this.storeItemsService
                .getStoreItems(this.page, 24, 'storeItemName', 'ASC', storeItemFilterInfo)
                .subscribe((storeItemResponse: StoreItemsResponse) => {

                    this.maxNoOfItems = storeItemResponse.resultCount;
                    if (this.maxNoOfItems > 0) {
                        this.isStoreItems = true;
                        this.carouselEndReached = false;
                    }
                    if (this.storeItemDetails.length >= this.maxNoOfItems) {
                        // reached end of list
                        this.carouselEndReached = true;
                    } else {
                        this.storeItemDetails = this.storeItemDetails.concat(
                            storeItemResponse.results
                        );
                        this.page++;
                        this.rowList = this.carouselViewGenerator();
                    }
                    this.isLoading = false;
                    this.spinnerStart = false;
                    this.ref.detectChanges();
                    this.calculatePadding();

                },
                    (err) => {
                        console.error(err.error);
                        this.isLoading = false;
                        this.spinnerStart = false;
                        this.calculatePadding();
                    }
                );
        }
    }

    carouselViewGenerator() {
        let rowList = [];
        let count = 0;
        for (let i = 0; i < this.storeItemDetails.length / this.itemsPerRow; i++) {
            const viewList = this.storeItemDetails.slice(count, count + this.itemsPerRow);
            let row = [];
            for (let j = 0; j < viewList.length; j++) {
                if (viewList[j] != null) {
                    row.push(viewList[j]);
                }
            }
            if (!!row && row.length > 0) {
                rowList.push(row);
            }
            count = count + this.itemsPerRow;
        }
        if (this.storeItemDetails.length <= this.itemsPerRow) {
             $('.carousel-control-next').hide();
             $('.carousel-control-prev').hide();
         } else {
             $('.carousel-control-next').show();
          //   $('.carousel-control-prev').show();
         }
        return rowList;
    }


    /* For Toggling the Store Items based on Toggle Click */
    /* Implementing this as we want to utilize the Space in case if Customer wants to edit the requests */
    toggleStore() {
        $('#storeCarouselControls').toggle();
        if (this.toggleIconFlag === true) {
            this.toggleIconFlag = false;
            $('#sd_global_search_heading_store').css('border-bottom', '1px solid rgba(192, 192, 192, 0.5)');
        } else {
            this.toggleIconFlag = true;
            $('#sd_global_search_heading_store').css('border-bottom', '0');
        }
        /* Calling the calculatePadding function to render Requests Layout below the Store */
        this.calculatePadding();
}

}
